import { useState } from "react";
import { navLinks } from "@/mocks/evidence";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur-md border-b border-background-200/80">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-newspaper-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              国产黑料
            </span>
            <span className="mt-1 text-[10px] uppercase tracking-[0.24em] text-foreground-500">
              Evidence Archive
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#pack"
            className="whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm text-primary-700 transition-colors hover:bg-primary-50"
          >
            <i className="ri-download-2-line mr-1.5" />
            证据整理包
          </a>
          <a
            href="#timeline"
            className="whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            复核入口
          </a>
        </div>

        <button
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-3">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <div className="mt-2 flex flex-col gap-2">
              <a
                href="#pack"
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md border border-primary-300 px-4 py-3 text-center text-sm text-primary-700"
              >
                <i className="ri-download-2-line mr-1.5" />
                证据整理包
              </a>
              <a
                href="#timeline"
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md bg-primary-600 px-4 py-3 text-center text-sm text-background-50"
              >
                复核入口
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}